export class LoadFinOpsAwsOnOffHistoricalData {
    static type = '[FINPS][AWS][ON/OFF] LoadFinOpsAwsOnOffHistoricalData'
}

export class LoadDataTableAllAccountsFinOpsAwsOnOffResources {
    static type = '[FINPS][AWS][ON/OFF] LoadDataTableAllAccountsFinOpsAwsOnOffResources'
}

export class LoadFinOpsAwsOnOffChartsData {
    static type = '[FINPS][AWS][ON/OFF] LoadFinOpsAwsOnOffChartsData'
}

export class LoadFinOpsAwsOnOffAllAccountsChartsFilteredData {
    static type = '[FINPS][AWS][ON/OFF] LoadFinOpsAwsOnOffAllAccountsChartsFilteredData'
}